import snakecaseKeys from 'snakecase-keys'
import axiosIns from '@/plugins/axios'

export default {
  createAggregationUser(aggregationId, userId) {
    return axiosIns.post(
      `/v2/eod_report/realtime_aggregations/${aggregationId}/aggregation_users`,
      snakecaseKeys({ userId }),
    )
  },
  destroyAggregationUser(aggregationId, aggregationUserId) {
    return axiosIns.delete(
      `/v2/eod_report/realtime_aggregations/${aggregationId}/aggregation_users/${aggregationUserId}`,
    )
  },
  getAvailableUsers(aggregationId) {
    return axiosIns.get(
      `/v2/eod_report/realtime_aggregations/${aggregationId}/available_users`,
    )
  },
}
